import axios from "axios";
import { SERVICEURL } from "../appconfig";

export interface GetLanguageDetailResponse {
  languageId: string;
  languageParameterId: string;
  speakingId?: string;
  writingId?: string;
  readingId?: string;
  isEnough: boolean;
}

export interface UpdateLanguagePayload {
  languageId: string;
  languageParameterId: string;
  speakingId?: string;
  writingId?: string;
  readingId?: string;
  isEnough: boolean;
}

export const getLanguageDetail = async (
  languageId: string
): Promise<GetLanguageDetailResponse> => {
  const token = localStorage.getItem("token");
  const response = await axios.get(
    `${SERVICEURL}api/Candidates/GetLanguageDetail/${languageId}`,
    {
      headers: {
        Authorization: `Bearer ${token}`,
        accept: "text/plain",
      },
    }
  );
  return response.data?.data || response.data;
};

export const updateLanguageInfo = async (
  payload: UpdateLanguagePayload
): Promise<any> => {
  const token = localStorage.getItem("token");
  const response = await axios.put(
    `${SERVICEURL}api/Candidates/UpdateLanguageInfo`,
    payload,
    {
      headers: {
        Authorization: `Bearer ${token}`,
        "Content-Type": "application/json",
        accept: "*/*",
      },
    }
  );
  return response.data;
};

export const deleteLanguageInfo = async (languageId: string): Promise<void> => {
  const token = localStorage.getItem("token");
  await axios.delete(
    `${SERVICEURL}api/Candidates/DeleteLanguageInfo/${languageId}`,
    {
      headers: {
        Authorization: `Bearer ${token}`,
      },
    }
  );
};
